<template>
  <div id="app">
    <template v-if="ismOrpc == 'Moperation'">
      <headerView v-show="isShowHead"></headerView>
      <router-view class="container" :key="key + $route.name" />
      <mobileFooterBox v-show="isShowFoot"></mobileFooterBox>
      <el-backtop class="to-top"></el-backtop>
    </template>

    <template v-else>
      <headTab>
        <router-view :key="key + $route.name" />
        <footerBox></footerBox>
        <el-backtop></el-backtop>
      </headTab>
      <div v-if="isLogin">
        <login></login>
      </div>
    </template>
  </div>
</template>

<script>
import headTab from "@/components/headTab.vue";
import footerBox from "@/components/footerBox.vue";
import login from "./components/login.vue";
import headerView from "@/components/mobile/headerNav.vue";
import mobileFooterBox from "@/components/mobile/footerBox.vue";
import {
  apiCollection,
  apiResource,
  apiFormSubmit,
  apiDelete,
  apiPut
} from "./api/index";
import { mapMutations, mapState } from "vuex";
export default {
  name: "App",
  components: {
    headTab,
    footerBox,
    login,
    headerView,
    mobileFooterBox
  },
  data() {
    return {
      isShowHead: false,
      isShowFoot: false,
      ismOrpc: "",
    };
  },
  methods: {
    //判断手机端还是PC端
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    ...mapMutations(["getIslogin"])
  },
  watch: {
    $route(to, from) {
      if (
        to.path == "/mb_index" ||
        to.path == "/mb_remoteEducation" ||
        to.path == "/mb_capacityTrain" ||
        to.path == "/mb_personCenter" ||
        to.path == "/mb_examinationRegist" ||
        to.path == "/mb_studyRoom" ||
        to.path == "/mb_schoolStyle" ||
        to.path == "/mb_examSearch"
      ) {
        this.isShowHead = true;
        this.isShowFoot = true;
      } else if (
        to.path == "/mb_remoteEducationSearch" ||
        to.path == "/mb_capacityTrainSearch" ||
        to.path == "/mb_questionnaire" ||
        to.path == "/mb_schoolStyleSearch"
      ) {
        this.isShowHead = true;
        this.isShowFoot = false;
      } else {
        this.isShowHead = false;
        this.isShowFoot = false;
      }
    }
  },
  computed: {
    ...mapState({
      isLogin: state => state.isLogin
    }),
    isLogin() {
      const value = localStorage.getItem("X-Access-Token");
      //   this.getIslogin(value ? true : false);
      if (value) {
        const arr = [
          apiCollection,
          apiResource,
          apiFormSubmit,
          apiDelete,
          apiPut
        ];
        arr.forEach(item => {
          item.defaults.headers["X-Access-Token"] = value;
        });
        return false;
      } else {
        const name = this.$route.name;
        return true;
      }
    },
    key() {
      return this.$route.name !== undefined
        ? this.$route.name + new Date()
        : this.$route + new Date();
    }
  },
  // beforeMount() {

  // },
  mounted() {
    window.onresize = () => {
      return (() => {
        if (document.body.clientWidth <= 600) {
          localStorage.setItem("projectType", "Moperation");
        } else {
          localStorage.setItem("projectType", "PCoperation");
        }
      })();
    };
  },
  beforeMount() {
    let flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    console.log("6/5", this._isMobile());
    if (flag) {
      //手机端
      this.ismOrpc = "Moperation";
      localStorage.setItem("projectType", this.ismOrpc);
      const value = localStorage.getItem("X-Access-Token");
      console.log(value);
      if (!value) {
        this.$router.replace({ path: "/mb_login" }).catch(err => {
          console.log("/");
        });
      }
    } else {
      //pc端
      this.ismOrpc = "PCoperation";
      localStorage.setItem("projectType", this.ismOrpc);
      // this.$router.replace({ path: "/" }).catch(err => {
      //   console.log("/");
      // });
    }
  }
};
</script>

<style lang="scss">
@import "./assets/fonts/iconfont.css";
#app {
  height: 100vh;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
  font-size: 14PX;
  font-family: 阿里巴巴普惠体;
}
@font-face {
  font-family: 阿里巴巴普惠体;
  src: url("./assets/font/Alibaba-PuHuiTi-Regular.otf");
}
body {
  margin: 0;
}
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
}
ul,
li {
  list-style: none;
}
a {
  text-decoration: none;
}
a:focus {
  outline: none;
}
.no-data-box {
  margin: 0 auto;
  font-size: 40px;
  text-align: center;
}
i {
  font-size: 20PX;
}
// img {
//   display: block;
//   max-width: 100% !important;
// }
/*滚动条样式*/
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background-color: #ccc;
}
::-webkit-scrollbar-thumb {
  border-radius: 0px;
  background-color: #f1a373;
}
::-webkit-scrollbar-track {
  border-radius: 0;
  background: #cccccc;
}
.container {
  padding-top: 96px;
  .van-nav-bar .van-icon {
    color: #000000;
  }
}
.to-top {
  bottom: 140px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue